// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ek","header":"el","message":"em","copyMessage":"en","button":"eo"};